import { http } from '@/utils/axios'

/**
 * @msg: 获取班级列表
 */
export function getElAlbumList(data) {
    return http({
        url: http.baseUrl('elAlbum/getElAlbumList'),
        method: 'post',
        params: http.params(data),
    })
}

/**
 * @msg: 开班
 */
export function openClass(data) {
    return http({
        url: http.baseUrl('elAlbum/openClass'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 禁用班级
 */
 export function disableClass(data) {
    return http({
        url: http.baseUrl('elAlbum/disableClass'),
        method: 'post',
        params: http.params(data),
    })
}

/**
 * @msg: 审核班级
 */
export function auditClass(data) {
    return http({
        url: http.baseUrl('elAlbum/checkClass'),
        method: 'post',
        params: http.params(data),
    })
}

/**
 * @msg: 班级课程列表
 */
 export function classCourseList(data) {
    return http({
        url: http.baseUrl('elAlbum/getElAlbumCourseList'),
        method: 'post',
        params: http.params(data)
    })
}

/**
 * @msg: 启用班级
 */
 export function enableClass(data) {
    return http({
        url: http.baseUrl('elAlbum/startClass'),
        method: 'get',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 删除班级
 */
 export function deleteClass(data) {
    return http({
        url: http.baseUrl('elAlbum/deleteClass'),
        method: 'get',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 启用班级
 */
 export function startApply(data) {
    return http({
        url: http.baseUrl('elAlbum/startApply'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 获取教师列表
 */
 export function getTeacherUserList(data) {
    return http({
        url: http.baseUrl('elUser/getTeacherUserList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg:确定分配教师列表
 */
 export function updateRkTeacher(data) {
    return http({
        url: http.baseUrl('zkolOrderCourseBatch/updateRkTeacher'),
        method: 'get',
        params: http.params(data)
    })
}

